import { Divider, Grid, Paper, Typography } from '@frontierag/frontier-ui-library';
import useDataFieldHelpers from 'hooks/useDataFieldHelpers';

import type { IDataColumns, IDataColumnsField } from './types';

export default function DataColumns({ data, columnProps, columnsSchema }: IDataColumns) {
  const { renderLabel, renderValue, isHidden } = useDataFieldHelpers<IDataColumnsField>(data);
  const columnsNumber = Math.ceil(12 / columnsSchema.length);

  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{ p: { xs: 2, sm: 3 }, borderRadius: 2 }}
      data-testid="data-columns-container"
    >
      <Grid container spacing={{ sm: 3, xs: 2 }}>
        {columnsSchema.map(({ fields, title, columns = 1 }) => (
          <Grid
            key={`data-column-${title}`}
            item
            xs={12}
            sm={columnsNumber > 4 ? columnsNumber : 3}
            {...columnProps}
          >
            <Typography variant="subtitle3">{title}</Typography>
            <Divider sx={{ mt: 1, mb: 2 }} component="div" />

            <Grid container spacing={2}>
              {fields.map((field) =>
                isHidden(field) ? null : (
                  <Grid
                    item
                    xs={12 / columns}
                    key={`data-columns-field-${field.accessor}`}
                    data-testid={`field-${field.accessor}`}
                    sx={{ wordWrap: 'break-word' }}
                    {...(field.gridProps ? field.gridProps : {})}
                  >
                    <Typography variant="label1">{renderLabel(field)}:</Typography>
                    <Typography variant="body2">{renderValue(field)}</Typography>
                  </Grid>
                ),
              )}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
